(function() {
    'use strict';
    angular
        .module('sideApp')
        .factory('NivelEducativoService', NivelEducativoService);

    NivelEducativoService.$inject = ['$resource'];

    function NivelEducativoService ($resource) {
        var resourceUrl =  'apo/nivelEducativo';//nohay

        return $resource(resourceUrl, {}, {
//            'query': { method: 'GET', isArray: true},
//            'get': {
//                method: 'GET',
//                transformResponse: function (data) {
//                    if (data) {
//                        data = angular.fromJson(data);
//                    }
//                    return data;
//                }
//            },
//            'update': { method:'PUT' },
            'getNivelByPlanAlumno': {
         	   url:'apo/getNivelByPlanAlumno/{nivPlan}',
         	   method: 'POST'
            }
        });
    }
})();
